import { render } from "./RekionAdminMenu.vue?vue&type=template&id=a46b229c&scoped=true&ts=true"
import script from "./RekionAdminMenu.vue?vue&type=script&lang=ts"
export * from "./RekionAdminMenu.vue?vue&type=script&lang=ts"

import "./RekionAdminMenu.vue?vue&type=style&index=0&id=a46b229c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a46b229c"]])

export default __exports__